export const getDevice = (): 'android' | 'ios' | '' => {
  if (typeof window === 'undefined') return '';

  const userAgent = navigator.userAgent || navigator.vendor;

  if (
    /android/i.test(userAgent) ||
    (navigator.maxTouchPoints > 0 &&
      userAgent.includes('linux') &&
      !userAgent.includes('mac'))
  ) {
    return 'android';
  }

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    return 'ios';
  }

  return '';
};
